import { lazy } from "react";

const GSTR1 = lazy(() => import("../Component/GST/GSTR1"));
const GSTR3 = lazy(() => import("../Component/GST/GSTR3"));

const gstRoutes = [
  { path: "/gstr1", element: <GSTR1 />, protected: true },
  { path: "/gstr3", element: <GSTR3 />, protected: true },
];

export default gstRoutes;
